export default __webpack_public_path__ + "static/Genuine Parts – Horizontal 800x400-4b233f804edec00c837ab39d400957f1.svg";